<div [id]="backgroundImageId" class="bg-image shadow" color="primary" *ngIf="!isPasswordLinkSent">
  <div class="mask d-flex align-items-center h-100">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-xl-5 col-md-8">
          <form action="submit" [formGroup]="resetPwdLinkForm" class="bg-white rounded shadow-5-strong p-4">
            <div class="d-flex justify-content-center" >
              <div class="col-md-8 col-sm-12 d-flex justify-content-center">
                <img [src]="logoUrl" alt="IEA logo" class="logo" />
              </div>
            </div>
            <div class="col-12 text-center">
              <h2>Reset your Password</h2>
              <p>After submitting your password reset request, check your email to create your new password.</p>
              <hr />
            </div>
            <div class="example-container mt-3">
              <div class="row">
                <div class="col-12">
                  <eq-email [form]="resetPwdLinkForm" [icon]="'mail'" [name]="'email'" [label]="'Email Address'" [validators]="emailValidators"
                    (onChange)="checkEmailExists($event)" class="mt-1"
                    [isForgotPassword]="true"
                    [placeholder]="'Enter Email Address'"
                    ></eq-email>
                </div>
              </div>
            </div>

            <button type="submit" (click)="resetPwd()" class="btn btn-primary btn-block w-100 py-3">
              Send Reset Password Link
            </button>

            <hr class="mt-4" />
            <div class="col-12 text-center mt-2">
              <img class="footer-logo" src="../../../assets/images/poweredby-OneEquineblack-logo.png" alt="IEA logo" />
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<div [id]="backgroundImageId" class="bg-image shadow" color="primary" *ngIf="isPasswordLinkSent">
  <div class="mask d-flex align-items-center h-100">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-xl-4 col-md-6">
          <form class="bg-white rounded shadow-5-strong p-4">
            <div class="col-12 text-center">
              <img
                [src]="logoUrl"
                alt="IEA logo"
                class="logo"
              />
              <h2> 
                <mat-icon class="resetpassword-success-icon" matSuffix>check_circle</mat-icon>
              </h2> 
              <h3>Email Sent!</h3>
              <p>
                Please check your email to reset your password.<br>
                If you don't see an email? Check your spam! <br>
              </p>
              <hr />
            </div>
            
            <!-- Submit button -->
            <button type="button" (click)="resend()" class="btn btn-primary btn-block w-100 py-3">
             Didn't receive?  Resend Email
            </button>

            <div class="col-12 text-center mt-2">
              <img
              class="footer-logo"
              src="../../../assets/images/poweredby-OneEquineblack-logo.png"
              alt="IEA logo"
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
  
  
  